import { useEffect, useRef } from "react";
import { useDispatch } from "react-redux";
import "./App.css";
import {
  getBranchesDataSharingWoLoader,
  getClinicDetailsWoLoader,
  getClinicStocksWoLoader,
  getServicesWoLoader,
} from "./redux/reducers/clinicSlice";
import { getClinicVetsWoLoader } from "./redux/reducers/vetSlice";
import Router from "./routes/Router";
import {
  isMandateStale,
  MANDATE_STALE_MS,
  msUntilNextMandateRefresh,
  writeMandateSession,
} from "./util/mandateSessionStorage";

const App = () => {
  const dispatch = useDispatch();
  const refreshTimerRef = useRef(null);

  useEffect(() => {
    const clearRefreshTimer = () => {
      if (refreshTimerRef.current != null) {
        clearTimeout(refreshTimerRef.current);
        refreshTimerRef.current = null;
      }
    };

    const scheduleNextFullMandateFetch = () => {
      clearRefreshTimer();
      refreshTimerRef.current = window.setTimeout(() => {
        fetchAndStoreMandate();
      }, MANDATE_STALE_MS);
    };

    const fetchAndStoreMandate = async () => {
      clearRefreshTimer();
      try {
        const [clinicRes, servicesRes, stocksRes, vetsRes, dataShareRes] =
          await Promise.all([
            dispatch(getClinicDetailsWoLoader()),
            dispatch(getServicesWoLoader()),
            dispatch(getClinicStocksWoLoader()),
            dispatch(getClinicVetsWoLoader("?type=all")),
            dispatch(getBranchesDataSharingWoLoader()),
          ]);
        const reqObj = {};
        if (clinicRes?.payload) {
          reqObj.clinic = clinicRes?.payload ?? {};
        }
        if (dataShareRes?.payload) {
          reqObj.dataSharing = dataShareRes?.payload?.[0] ?? {};
        }
        if (servicesRes?.payload) {
          reqObj.services = servicesRes?.payload?.data ?? [];
        }
        if (stocksRes?.payload) {
          reqObj.stocks = stocksRes?.payload?.data ?? [];
        }
        if (vetsRes?.payload) {
          reqObj.vets = vetsRes?.payload?.data ?? [];
        }
        writeMandateSession(reqObj);
      } catch (err) {
        console.error(err);
      } finally {
        scheduleNextFullMandateFetch();
      }
    };

    if (isMandateStale()) {
      fetchAndStoreMandate();
    } else {
      refreshTimerRef.current = window.setTimeout(() => {
        fetchAndStoreMandate();
      }, msUntilNextMandateRefresh());
    }

    return () => clearRefreshTimer();
  }, [dispatch]);

  return <Router />;
};

export default App;
